goog.provide('el8.ptdata.model.med.medOrder');

goog.require('el8.model.base');
goog.require('el8.ptdata.model.med.base');
goog.require('el8.ptdata.model.med.fulfillmentMgr');
goog.require('el8.ptdata.model.med.medOrderDetailsMgr');
goog.require('el8.template.ptdata.model.medOrder');

(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8.ptdata.model.med.base);
    _class.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec.fulfillments) {
            if (!this.getFulfillmentMgr()) {
                this.setFulfillmentMgr(new el8.ptdata.model.med.fulfillmentMgr());
            }
            this.getFulfillmentMgr().loadFulfillments(spec.fulfillments);
        }
        if (spec.details) {  // If details get sent down
            if (!this.getDetailsMgr()) {
                this.setDetailsMgr(new el8.ptdata.model.med.medOrderDetailsMgr());
            }
            this.getDetailsMgr().populate(spec.details);
        }
        if (spec.thread) {
            el8.ptdata.medOrderThreads.create(spec.thread, true);
        }
        var syncToRedux;
        if (!this.isSignedOff()) {
          // Updates to draft medOrders already occur in React/Redux, so no need to re-sync back to Redux
          syncToRedux = false
        }
        el8.ptdata.model.med.base.prototype.populate.call(this, spec, syncToRedux);
    };

    _class.addStringProperty("origin");
    _class.addStringProperty("printType", true);
    _class.addStringProperty("directions", true); // a.k.a. sig
    _class.addStringProperty("type", true);
    _class.addStringProperty("medicationType");
    _class.addStringProperty("displayType");
    _class.addStringProperty("quantity", true);
    _class.addStringProperty("quantityUnits", true);
    _class.addIntProperty("authRefills", true);
    _class.addIntProperty("daysSupply", true);
    _class.addStringProperty("numSamples", true);
    _class.addStringProperty("indication", true);
    _class.addStringProperty("pharmacyInstructions", true);
    _class.addStringProperty("notes", true);
    _class.addBoolean("prescription");
    _class.addBoolean("allowSubstitutions", true, null);
    _class.addBoolean("selfPrescribed", true);
    _class.addDate("startDate", true, el8.service.tz.today());
    _class.addBoolean("hasInteractions");
    _class.addDateTime('fulfillmentTime');
    _class.addBoolean("fulfillmentRequired");
    _class.addProperty("fulfillmentMgr");

    _class.addBoolean("surescripts");
    _class.addBoolean("documentMed");
    _class.addBoolean("postDated");
    _class.addBoolean("eRx");
    _class.addBoolean("bulkRefillable");
    _class.addBoolean("controlled");

    _class.addIcd10s();
    _class.addProperty('icd10Descs', false);

    /** Detail that may not always be populated for a given order **/
    _class.addProperty("detailsMgr");
    /** Used for order forms, carrying data up and down **/
    _class.addProperty("metadata", false, {});

    _class.addDateTime("createDate", true, null);
    _class.addIntProperty("templateId", true);
    _class.addStringProperty("medCreationType", false);

    _class.addStringProperty("latestFillStatus");
    _class.addDate("latestFillDate");
    _class.addStringProperty("latestFillNote");

    // For OH rx reports
    _class.addStringProperty("actionType");

    /**
     * Thread related methods
     */
    _class.prototype.isThreadActive = function() {
        var thread = el8.ptdata.medOrderThreads.getById(this.getThreadId());
        if (thread) { return thread.isActive(); }
        return false; // if there's no thread, the thread's been deleted and is not active
    };
    _class.prototype.isThreadPermanent = function() {
        var thread = el8.ptdata.medOrderThreads.getById(this.getThreadId());
        if (thread) { return thread.isPermanent(); }
        return false; // if there's no thread, the thread's been deleted and we'll assume non-permanent
    };

    /**
     * CONVENIENT DISPLAY METHODS
     */
    _class.prototype.isPostDated = function() {
        return this.getStartDate() > el8.service.tz.newTzDate(this.getDocumentDate());
    };
    _class.prototype.getPrescriberFullName = function() {
        return this.isSelfPrescribed() ? 'Patient' :
                (this.getPrescribingPhysicianId() ? this.getPrescribingPhysicianName() :
                 'Prescriber Not Specified');
    };

    _class.prototype.isCanceled = function() {
        var fulfillmentMgr = this.getFulfillmentMgr();
        if (fulfillmentMgr) {
            return fulfillmentMgr.isLatestCancelSuccess();
        }
        return false;
    };

    _class.prototype.isCancelPending = function() {
        var fulfillmentMgr = this.getFulfillmentMgr();
        if (fulfillmentMgr) {
            return fulfillmentMgr.isLatestCancelPending();
        }
        return false;
    };

    _class.prototype.isCancelDenied = function() {
        var fulfillmentMgr = this.getFulfillmentMgr();
        if (fulfillmentMgr) {
            return fulfillmentMgr.isLatestCancelDenied();
        }
        return false;
    };

    _class.prototype.isCancelSent = function() {
        var fulfillmentMgr = this.getFulfillmentMgr();
        if (fulfillmentMgr) {
            return fulfillmentMgr.isLatestCancelSent();
        }
        return false;
    };

    _class.prototype.isCancelIgnored = function() {
        var fulfillmentMgr = this.getFulfillmentMgr();
        if (fulfillmentMgr) {
            return fulfillmentMgr.isLatestCancelIgnored();
        }
        return false;
    };

    _class.prototype.isChanged = function() {
        var fulfillmentMgr = this.getFulfillmentMgr();
        if (fulfillmentMgr) {
            return fulfillmentMgr.isLatestChanged();
        }
        return false;
    };

    /**
     * @returns {bool}
     */
    _class.prototype.isChangeDenied = function() {
        var fulfillmentMgr = this.getFulfillmentMgr();
        return Boolean(fulfillmentMgr && fulfillmentMgr.isLatestChangeDenied());
    }

    _class.prototype.asSoyMap = function() {

        var mapped = this.parent.asSoyMap.call(this);

        mapped['documentingPersonnelName'] = this.getDocumentingPersonnelName();
        mapped['documentedOtherPrescriberName'] = (this.isDocumentMed() &&
            this.isOtherPrescriberDocumented()) ? this.getPrescriberFullName() : null;
        mapped['rxPrescriberName'] = (!this.isDocumentMed() && !this.isRxDownload()) ?
            this.getPrescriberFullName() : null;
        mapped['rxDownloadPrescriberName'] = this.isRxDownload() ?
            this.getRxDownloadPrescriberName() : null;
        mapped['supervisingPhysicianName'] = this.getSupervisingPhysicianName();

        if (!this.isRxDownload()) {
            // RxHistoryDownloadMedOrders are not actually signable but they have a sign_user_id of 2
            mapped['signUserName'] = this.getSignUserName();
            mapped['signUserBehalfName'] = this.getSignUserBehalfName();
        }

        mapped['isThreadActive'] = this.isThreadActive();

        /** Only for feedSummary **/
        var fulfillmentMgr = this.getFulfillmentMgr();
        if (fulfillmentMgr) {
            var latestExternalFulfillment = this.getFulfillmentMgr().getLatestExternalFulfillment();
            mapped['fulfillments'] = this.getFulfillmentMgr().getAllFulfillments().map(
                function(f) { return f.asSoyMap(); });
            mapped['latestExternalFulfillment'] = latestExternalFulfillment ?
                latestExternalFulfillment.asSoyMap() : null;
        }

        mapped['isCanceled'] = this.isCanceled();
        mapped['isCancelPending'] = this.isCancelPending();
        mapped['isCancelSent'] = this.isCancelSent();
        mapped['isCancelIgnored'] = this.isCancelIgnored();
        mapped['isCancelDenied'] = this.isCancelDenied();
        mapped['isChanged'] = this.isChanged();
        mapped['isChangeDenied'] = this.isChangeDenied();

        /* only when printing, meds hx drawer detail */
        mapped['details'] = this.getDetailsMgr() ? this.getDetailsMgr().asSoyMap() : null;
		mapped['bulkRefillable'] = this.isBulkRefillable();
		mapped['isThreadPermanent'] = this.isThreadPermanent();

        // apply timezone for fulfillment time if available
        if (this.getFulfillmentTime()) {
            mapped['fulfillmentTime'] = el8.service.tz.soyStr(this.getFulfillmentTime());
        }
        return mapped;
    };

    /**
     * FULFILLMENT RELATED
     */
    _class.prototype.isNeedsFulfillment = function() {
        return this.isFulfillmentRequired() && !this.getFulfillmentMgr().hasFulfillment();
    };
    _class.prototype.markPrinted = function() {
        // Mark us as fulfilled-via-print.
        this.getFulfillmentMgr().addFulfillment({
            state: 'complete',
            type: 'paper',
            timeCompleted: el8.service.tz.now()
        });
    };
    _class.prototype.markFaxed = function() {
        // Mark us as fulfilled-via-fax
        this.getFulfillmentMgr().addFulfillment({
            state: 'complete',
            type: 'fax',
            timeCompleted: el8.service.tz.now()
        });
    };
    _class.prototype.markERxState = function(opts) {
        // Mark us as fulfilled-via-erx
        opts = opts || {};
        opts['type'] = 'surescripts';
        opts['timeCompleted'] = el8.service.tz.now();
        this.getFulfillmentMgr().addFulfillment(opts);
        this.setFulfillmentRequired(opts.required);
    };

    /**
     * RENDERING METHODS
     */
    _class.prototype.getPatientSummary = function() {
        return this.getNoteOwnedDocSummary(true);
    };
    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.model.medOrder.noteSummary(this.asSoyMap()).el8_unescape();
    };
    _class.prototype.getNoteOwnedDocSummary = function(forServer) {
        /**
         * When med order is owned by note:
         *   - If forServer=true, return the (string, formatting) pair that needs
         *     to get sent to the server
         *    - Else, return the HTML summary
         */
        var soyMap = this.asSoyMap();
        var typeStr = el8.template.ptdata.model.medOrder.ownedDocSummaryType(soyMap).el8_unescape();
        var descriptionStr = el8.template.ptdata.model.medOrder.ownedDocSummaryDescription(soyMap).el8_unescape();
        var startDateStr = el8.template.ptdata.model.medOrder.ownedDocSummaryStartDate(soyMap).el8_unescape();

        /* These templates have HTML in them, and rather than not use the shared template,
         * we just strip out the html here using jQuery manipulation */
        var instrStr = $('<span>').html(
            el8.template.ptdata.model.medOrder.ownedDocSummaryInstr(soyMap)).text();

        var otherPrescriberStr = $('<span>').html(
            el8.template.ptdata.model.medOrder.ownedDocSummaryOtherPrescriber(soyMap)).text();

        var summaryStr = typeStr + descriptionStr + instrStr + otherPrescriberStr + startDateStr;
        var formatting = [
            {"decoration": "tag_item", "offsets": [0, typeStr.length]}
        ];
        if (instrStr) {
            var textToFormat = "Instr:";
            var instrStrStart = summaryStr.indexOf(textToFormat);
            if (instrStrStart !== -1) {
                formatting.push({
                    "decoration": "light_app_color",
                    "offsets": [instrStrStart, instrStrStart + textToFormat.length]
                });
            }
        }
        if (otherPrescriberStr) {
            /* Other prescriber str has a space in front of the formatted area */
            var trueOtherPrescriberStr = otherPrescriberStr.substr(1);
            var otherPrescriberStrStart = summaryStr.indexOf(trueOtherPrescriberStr);
            formatting.push({
                "decoration": "light_app_color",
                "offsets": [otherPrescriberStrStart, otherPrescriberStrStart + trueOtherPrescriberStr.length]
            });
        }

        var result = {
            summary: summaryStr,
            summary_formatting: formatting
        };
        return forServer ? result :
            el8.util.format(result['summary'], result['summary_formatting']);
    };

    _class.prototype.getOrderType = function() { return 'meds'; };
    _class.prototype.getDescription = function() {
        return this.isDocumentMed() ? 'Med' : 'Prescription';
    };
    _class.prototype.getNotifyText = function(type) {
        var text = (this.isDocumentMed() ? 'med' : 'prescription');
        switch(type) {
            case 'ADD_TO_NOTE':
                return text.capitalize() + ' added to current note';
            case 'DISCONTINUE':
                return 'Med ' + this.getDisplayedMedicationName() + ' discontinued. Noted in chart, and meds list updated.';
            case 'SAVE_IN_PROGRESS':
                if (!this.isSignedOff()) {
                    return 'Placing ' + text + ' on hold...';
                } else {
                    return 'Saving ' + text + '...';
                }
                break;
            case 'SAVE_COMPLETE':
                if (!this.isSignedOff()) {
                    return text.capitalize() + ' placed on hold.';
                } else {
                    return text.capitalize() + ' filed.';
                }
                break;
            case 'DELETE_COMPLETE':
                return text.capitalize() + ' discarded';
            case 'DELETE_IN_PROGRESS':
                return 'Discarding ' + text.capitalize() + '...';
            case 'SAVE_ERROR':
                return 'ERROR: Sorry, save not complete. Please try again.';
        }
    };
    _class.prototype.getLatestPharmacyNcpdpid = function() {
        var fulfillmentMgr = this.getFulfillmentMgr();
        if (fulfillmentMgr) {
            var latestExternalFulfillment = fulfillmentMgr.getLatestExternalFulfillment();
            if (latestExternalFulfillment) {
                return latestExternalFulfillment.getPharmacyNcpdpid();
            }
        }
        return null;
    }

    /**
     * Managing additional med order detail
     */
    _class.prototype.fetchRefillRequest = function(successCb) {
        // Note: Use of this method assumes that we have the detailsMgr of the model
        // already.  If not, we need to add ability to fetch details on the fly.
        if (this.getDetailsMgr()) {
            var details = this.getDetailsMgr();
            if (details.getRespondedRefillRequestId()) {
                var refReq = el8.ptdata.rxRefillRequests.getById(details.getRespondedRefillRequestId());
                if (successCb) { successCb(refReq.getOriginalSpec()); }
                return;
            } else {
                if (successCb) { successCb(null); }
                return;
            }
        } else {
            UIM && UIM.logError('Tryingt to fetch refill request for '+this.getId()+' without details');
            return;
        }
    };

    /**
     * Creating a copy for refills, re-ordering, etc.
     */
    _class.prototype.getCopy = function() {
        return el8.ptdata.model.med.medOrder({
            model_class: this.getModelClass(),
            thread_id: this.getThreadId(),
            is_prescription: this.isPrescription(),
            medication_id: this.getMedicationId(),
            directions: this.getDirections(),
            icd10_ids: this.getIcd10Ids(),
            indication: this.getIndication(),
            pharmacy_instructions: this.getPharmacyInstructions(),
            is_allow_substitutions: this.isAllowSubstitutions(),
            quantity: this.getQuantity(),
            quantityUnits: this.getQuantityUnits(),
            auth_refills: this.getAuthRefills(),
            print_type: this.getPrintType()
        });
    };

    /**
     * Error-checking/validation
     */
    _class.prototype.isQuantityNumerical = function() {
        return !this.getQuantity() || (this.getQuantity() && !isNaN(this.getQuantity()));
    };
    _class.prototype.isQuantityUnitsValid = function(main) {
        /* There is also a Surescripts restriction that it be
         * fewer than 15 characters, but we enforce this in the input field
         */
        if (!this.getQuantity() || !this.getQuantityUnits()) { return true; }

        var validUnits = el8.util.consts.MED_ORDER_QUANTITY_UNITS_LOWERCASE;
        if (main.isEPrescribingControlled() && el8Globals.FEATURES.NewSurescriptsEPCS) {
            validUnits = el8.util.consts.SURESCRIPTS_ALLOWED_QUANTITY_UNITS;
        }
        if ( !_.contains(validUnits, this.getQuantityUnits().toLowerCase()) ) {
            return false;
        }
        return true;
    };
    _class.prototype.isAuthRefillsNumerical = function() {
        return !this.getAuthRefills() ||
            // Must be a number
            (!isNaN(this.getAuthRefills()) &&
            // No decimal points or fractions
            (this.getAuthRefills().toString().indexOf('.') === -1) &&
            (this.getAuthRefills().toString().indexOf('/') === -1));
    };

    el8.ptdata.model.med.medOrder = function(spec) { return new _class(spec); };

})();
